<template>
  <div
    class="formulate-input-wrapper"
    :data-type="context.type"
  >
    <input
      class="formulateinput formulateinputdate"
      type="date"
      :placeholder="context.attributes.placeholder"
      v-model="context.model"
      v-bind="context.attributes"
      @blur="context.blurHandler"
      required
    >
  </div>
</template>

<script>
export default {
    props: {
        context: {
          type: Object,
          required: true
        },
    },
}
</script>
